'use strict';

/*
  _MobileAPI

  This class enables the setup of parameters for the mobile teams. These parameters allow
  for the implementation of specific functionality for the mobile teams when loading the site
  through a webview. When loading a webview, these parameters can be set at anytime, and is
  not dependent on this class nor any other libraries to have completed loading.

  These parameters are set as follows (example):
      mogo.params.theParameter = theValue;
      mogo.params.anotheParameter = someOtherValue;

  Parameters need to be implemented through the setupParameters and addParameters method
  below. See specific methods for additional information.
*/
function _MobileAPI() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  this.init = function () {
    this.initMobileAPI();
  };

  this.initAllReady = function () {};

  this.initMobileAPI = function () {
    if (!mogo.params) {
      mogo.params = {};
    }
    if (!mogo.params.props) {
      mogo.params.props = {};
    }

    this.initParameters();
    this.setUrlParams();
  };

  /*
      Sets up (activates) parameters when this class is initialized. Additional parameters
      should be created inside this method using `addParameter` unless these parameters should
      not be initialized automatically.
  */
  this.initParameters = function () {
    // Webview global parameter
    this.addParameter('webview', this._setWebView);
    // Header parameter
    this.addParameter('header', this._setHeader);
    // Subheader parameter
    this.addParameter('subheader', this._setSubheader);
  };

  /*
      Sets params immediately if they are passed in url.
  */
  this.setUrlParams = function () {
    // check for param in url to set immediately. eg /section/page?mobilewebapi_webview=true
    var allParams = window.location.search.substring(1).split('&');
    for (var i = allParams.length - 1; i >= 0; i--) {
      var pKey = allParams[i].split('=')[0];
      if (pKey.includes('mobilewebapi_')) {
        this.setParameter(pKey);
      }
    }
  };

  /*
      Sets params immediately if they are passed in url.
  */
  this.setParameter = function (name) {
    var paramVal = getURLParameter(name).trim(0);
    if (paramVal) {
      var shortName = name.split('mobilewebapi_')[1];
      mogo.params[shortName] = paramVal === 'true';
    }
  };

  /*
      Add a parameter to the API.
       Arguments:
          param [string] (required):
              The name of the parameter, which will be accessed by calling
              mogo.params.theParameterName.
       Returns:
          true if successful, false otherwise.
  */
  this.addParameter = function (param, func) {
    if (typeof param !== 'string' || typeof func !== 'function') {
      return false;
    }

    if (mogo.params.props['_' + param]) {
      return false;
    }

    var temp = typeof mogo.params[param] === 'undefined' ? undefined : mogo.params[param];
    mogo.params.props['_' + param] = undefined;
    Object.defineProperty(mogo.params, param, {
      set: function (fn, x) {
        this.props['_' + param] = x;
        fn(x);
      }.bind(mogo.params, func),
      get: function () {
        return this.props['_' + param];
      }.bind(mogo.params)
    });

    if (typeof temp !== 'undefined') mogo.params[param] = temp;

    return true;
  };

  /*
      Parameters specific functionality
  */

  /*
      WebView global functionality
  */
  this._setWebView = function (val) {
    // Shows or hides the smartbanner in the Portal in mobile when webview is true
    if (val === false) {
      $('#branch-banner-iframe').css('display', '');
      $('.layout-portal').css('margin-top', '');
      $('#main-nav').css('margin-top', '');
    } else {
      $('#branch-banner-iframe').css('display', 'none');
      $('.layout-portal').css('margin-top', '0');
      $('#main-nav').css('margin-top', '0');
      // do it again if the banner wasnt done loading:
      branch.addListener('didShowJourney', function () {
        // slight delay because didShowJourney event fires a bit early
        setTimeout(function () {
          branch.closeJourney(function (err, data) {
            console.log(err, data);
          });
          $('#branch-banner-iframe').css('display', 'none');
          $('.layout-portal').css('margin-top', '0');
          $('#main-nav').css('margin-top', '0');
        }, 100);
      });
    }
  };

  /*
      Shows or hides the main header in the Portal in mobile view.
  */
  this._setHeader = function (val) {
    if (val === false) {
      $('.portal__nav__mobile').css('display', 'none');
      $('.portal__content').css('margin-top', '0');
    } else {
      // Remove inline display property
      $('.portal__nav__mobile').css('display', '');
      $('.portal__content').css('margin-top', '');
    }
    if ($('#Notification') && $('#Notification').mogo().declaredClass) {
      $('#Notification').mogo().setPositioning();
    }
  };

  /*
      Shows or hides the subheader (to navigate to tray navigation) in the Portal in mobile
      view when applicable.
  */
  this._setSubheader = function (val) {
    if (val === false) {
      $('.portal__subnav').css('display', 'none');
    } else {
      // Remove inline display property
      $('.portal__subnav').css('display', '');
    }
  };

  /*
   ------------------------------
   */

  this.destroy = function () {};
}